const Homepage = () => {
    return null;
};

export default Homepage;
